module.exports = __webpack_public_path__ + "static/media/cn.pictogram.a6e3c906.svg";